import { render, staticRenderFns } from "./AppDisplay.vue?vue&type=template&id=5257a7bb&scoped=true&"
import script from "./AppDisplay.vue?vue&type=script&lang=ts&"
export * from "./AppDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257a7bb",
  null
  
)

export default component.exports